<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cdDYlu/tc-custom/9781455618958.jpg?1680421234552" alt="This image is the cover for the book Confederacy's First Battle Flag, The"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Confederacy's First Battle Flag, The
      </h1>
      <p class="bookDescription body article font2">
        <p>The original, hand-stitched silk flag with gold-painted stars was designed for the Confederate Army of the Potomac after the first battle of Manassas. It was created as a military necessity, without the authority or knowledge of the Confederate government-however, it filled a dire need. Gens. P. G. T. Beauregard and Joseph E. Johnston recognized that Confederate units needed to have an identifiable banner to unite them on the battlefield. A sketch of this flag design was provided to Mary Lyon Jones of Richmond, Virginia, who stitched the first Confederate battle flag.The original battle flag of the Confederate Armed Forces, incorporating the heraldic St. Andrew's Cross, remains a symbol of southern strength and resilience to this day. This fascinating account outlines the history of the design and creation of the flag that became the prototype for the iconic banner. Complete with more than fifty rare and previously unpublished photographs, author Kent Masterson Brown delivers a detailed history of the flag, including the generals and seamstresses who were instrumental in bringing the battle flag to life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kent Masterson Brown
      </h2>
      
      <p class="authorDescription body article">A writer, historian, and documentary filmmaker, Kent Masterson Brown is a leading expert on the Civil War. He is the president and content developer for Witnessing History, LLC, for which he has written, hosted, and produced multiple award-winning documentaries. Airing on PBS and other networks, his documentaries have earned five Telly Awards.  Brown was the founder and first editor of the national magazine The Civil War and the creator of its popular Civil War seminars. He has authored numerous Civil War titles, which have garnered him such literary awards as the United States Army Historical Foundation Award for Distinguished Writing in History and the General Basil W. Duke Literary Award. In addition, he served as the first chairman of the Gettysburg National Military Park Advisory Commission, a position to which he was appointed by Pres. George H. W. Bush.  He has written numerous articles for scholarly historical journals and regularly leads Civil War battlefield tours. A highly sought-after speaker, he lectures on the Civil War and American history all across the nation. He is a member of nearly a dozen organizations, including the Gettysburg Foundation and the Sons of the Revolution.  Brown received a JD from Washington and Lee University School of Law in Lexington, Virginia. He worked as a lawyer for the next thirty-seven years while simultaneously pursuing his interest in history. He lives in Lexington, Kentucky, with his wife and children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a505048e